import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'documentCheckDeletePipe'
})
export class DocumentCheckDeletePipe implements PipeTransform {

  transform(dataItem: any, memberName?: any,canDelete?:boolean): any {
    if ((dataItem.createdBy === memberName) && canDelete && (dataItem.trans_type != 'Approved'))
      return true;
    else
      return false;
  }

}
